<template>
    <div id="selectBook">
        <headers :title='titles'
                 :type='is_active'></headers>
        <div class="book_area">
            <div class="grade_list">
                <div class="grade_item active">围棋启蒙</div>
            </div>
            <div class="book_list">
                <div class="book_item"
                     v-for="(item,index) in chapter_list"
                     @click="chooceBook(item)"
                     :key="index">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'

export default {
    data () {
        return {
            titles: '设置教材',
            sid: this.$route.params.sid,
            type: this.$route.params.type,
            code: this.$route.params.code,
            classlist: [{ id: 1, name: '围棋启蒙' }],
            active_id: null,
            chapter_list: [],
        }
    },
    components: {
        headers,
        noResouse
    },
    created () {
        this.get_list()
    },
    methods: {
        get_list () {
            this.$http.post(API_URL_TASK_API + '/public/course/get_list', { book_type: 1 }).then(res => {
                if (res.data.response == 'ok') {
                    this.chapter_list = res.data.data
                }
            });
        },
        chooceBook (item) {
            let _that = this
            layer.open({
                title: '提示',
                diff: 'tea',
                content: `确认使用此本教材?`,
                btn: ['确定', '取消'],
                yes: function (index) {
                    let _data = { book_id: item.id, code: _that.code, sid: _that.sid }
                    _that.$http.post(API_URL_TASK_API + '/public/book/set_book', _data).then(res => {
                        layer.close(index);
                        if (res.data.response === 'ok') {
                            layer.open({
                                content: '设置成功',
                                skin: 'msg',
                                time: 2000
                            });
                            _that.$router.go(-1);
                        } else {
                            layer.open({
                                content: res.data.message,
                                btn: ['好的'],
                                skin: 'msg',
                                time: 5
                            });
                        }
                    })
                }
            })
        },
    },
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.book_area {
    display: flex;
    min-height: calc(100vh - 2.4rem);
    .grade_list {
        width: 205px / $ppr;
        background: #fff;
        border-right: 1px / $ppr solid #fff;
        .grade_item {
            line-height: 96px / $ppr;
            text-align: center;
            border-bottom: 1px / $ppr solid #fff;
            &.active {
                background-color: #f1f1f1;
                color: #5e89ef;
            }
        }
    }
    .book_list {
        background-color: #f1f1f1;
        flex: 1;
        .book_item {
            padding: 0 24px / $ppr;
            line-height: 96px / $ppr;
            border-bottom: 1px / $ppr solid #f1f1f1;
            &.active {
                background-color: #f1f1f1;
                color: #5e89ef;
            }
        }
    }
}
</style>
<style rel="stylesheet/scss" lang="scss">
.noresouse {
    .spinner {
        margin-top: -5.85rem !important;
    }
}
</style>
